import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useDeleteVehicleTypeOverrideMutation } from '@/api/adminServiceApi'

const DeleteOverrideDialog = ({ open, item, buildingId, onClose }) => {
  const { t } = useTranslation()
  const [deleteOverride, { isLoading, error }] = useDeleteVehicleTypeOverrideMutation()

  const handleDelete = async () => {
    try {
      await deleteOverride({ buildingId, id: item.id }).unwrap()
      onClose()
    } catch {
      // ошибка показывается в Alert
    }
  }

  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('vehicle_type_overrides_delete_title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('vehicle_type_overrides_delete_text', { plate: item?.plate_number })}
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {(error as any)?.data?.message || t('error_occurred')}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>{t('cancel')}</Button>
        <Button color="error" variant="contained" onClick={handleDelete} disabled={isLoading}>
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteOverrideDialog
